import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

interface ScrollParallaxProps {
  children: React.ReactNode;
  speed?: number;
  direction?: 'y' | 'x';
  start?: string;
  end?: string;
  className?: string;
}

export default function ScrollParallax({
  children,
  speed = -20,
  direction = 'y',
  start = 'top bottom',
  end = 'bottom top',
  className = '',
}: ScrollParallaxProps) {
  const ref = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    if (!ref.current) return;

    // Disable on mobile (< 768px) and when reduced motion is preferred
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isMobile || prefersReducedMotion) return;

    // Reduce speed on tablet (768-1024px) for subtlety
    const isTablet = window.matchMedia('(max-width: 1024px)').matches;
    const adjustedSpeed = isTablet ? speed * 0.5 : speed;

    gsap.to(ref.current, {
      [direction]: adjustedSpeed,
      ease: 'none',
      scrollTrigger: {
        trigger: ref.current,
        start,
        end,
        scrub: true,
      },
    });
  }, { scope: ref });

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
